import axiosInstance from "./axiosInstance";

export const getReportColumns = async () => {
  const res = await axiosInstance.get(`/admin/getreport`);
  return res.data;
};

export const generateReport = async (data) => {
  try {
    const response = await axiosInstance.post(`/admin/generatereport`, data, {
      responseType: "blob",
    });

    console.log("ExcelData:", response.data);

    return response.data;
  } catch (err) {
    console.error("API Error:", err);
    throw new Error(err.response?.data?.message || "Failed to generate report");
  }
};

export const getUserReportFields = async () => {
  try {
    const res = await axiosInstance.get(`/admin/reporting/configurations`);
    return res.data;
  } catch (err) {
    console.error("Failed to fetch user report fields:", err);
    throw new Error(
      err.response?.data?.message || "Failed to fetch user fields"
    );
  }
};

export const saveUserReportingConfigurationForVessel = async (
  vesselId,
  selectedFields
) => {
  try {
    const data = {
      selectedFields: selectedFields.map((field) => field.label),
      reportScope: "vessel",
    };

    if (vesselId) {
      data.vesselId = vesselId;
    }

    const res = await axiosInstance.post(
      `/admin/reporting/createconfiguration`,
      data
    );
    return res.data;
  } catch (err) {
    console.error("Failed to save user reporting configuration:", err);
    throw new Error(
      err.response?.data?.message || "Failed to save user configuration"
    );
  }
};
